import { render, staticRenderFns } from "./server-detail.vue?vue&type=template&id=890372d0&"
import script from "./server-detail.vue?vue&type=script&lang=js&"
export * from "./server-detail.vue?vue&type=script&lang=js&"
import style0 from "./server-detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports